(function(){
  'use strict';
  function cutTest(img){
    try{
      var N=24,c=document.createElement('canvas');c.width=c.height=N;
      var x=c.getContext('2d',{willReadFrequently:true});x.drawImage(img,0,0,N,N);
      var d=x.getImageData(0,0,N,N).data,mn=255,mx=0;
      function at(X,Y){var i=(Y*N+X)*4,l=d[i]*.3+d[i+1]*.59+d[i+2]*.11;if(l<mn)mn=l;if(l>mx)mx=l;}
      for(var k=0;k<N;k++){at(k,0);at(k,N-1);at(0,k);at(N-1,k);}
      return mn>=196&&mx-mn<=22;
    }catch(e){return null;}
  }
  function whenLoaded(img,cb){if(!img){cb();return;}if(img.complete&&img.naturalWidth){cb();return;}img.addEventListener('load',cb,{once:true});img.addEventListener('error',cb,{once:true});}
  function setup(m){
    if(m.__dxg)return;m.__dxg=1;
    var L=[].slice.call(m.querySelectorAll('.dxg__l'));if(!L.length)return;
    var res=[],i=0;
    function done(){
      var mi=-1;for(var k=0;k<res.length;k++){if(res[k]===false){mi=k;break;}}
      if(mi<0)mi=0;
      var main=L[mi];main.classList.add('is-main');main.classList.toggle('is-cut',res[mi]!==false);
      var ai=mi+1<L.length?mi+1:(mi>0?0:-1);
      if(ai>-1){var A=L[ai],ia=A.querySelector('img');A.classList.add('is-alt','is-cut');whenLoaded(ia,function(){A.classList.toggle('is-cut',cutTest(ia)!==false);});}
    }
    function next(){
      if(i>=L.length){done();return;}
      var im=L[i].querySelector('img');
      if(im&&!im.complete)im.loading='eager';
      whenLoaded(im,function(){res[i]=cutTest(im);if(res[i]===false){i=L.length;done();return;}i++;next();});
    }
    next();
  }
  var io='IntersectionObserver' in window?new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){io.unobserve(e.target);setup(e.target);}});},{rootMargin:'500px 0px'}):null;
  function watch(root){root.querySelectorAll('[data-dxg-m]').forEach(function(m){if(m.__w)return;m.__w=1;if(io)io.observe(m);else setup(m);});}
  function rd(k){try{return localStorage.getItem(k);}catch(e){return null;}}
  function wr(k,v){try{localStorage.setItem(k,v);}catch(e){}}

  function init(s){
    if(s.__dxg)return;s.__dxg=1;
    var sid=s.getAttribute('data-sid'),base=s.getAttribute('data-url');
    var dr=s.querySelector('[data-dxg-dr]'),form=s.querySelector('[data-dxg-form]'),bar=s.querySelector('[data-dxg-bar]');
    watch(s);

    function topH(){var h=document.querySelector('.shopify-section-group-header-group.ew-header')||document.querySelector('sticky-header');var t=0;if(h){var cs=getComputedStyle(h);if(cs.position==='sticky'||cs.position==='fixed')t=Math.round(h.getBoundingClientRect().height);}s.style.setProperty('--dxg-top',t+'px');return t;}
    topH();window.addEventListener('resize',topH);

    var cd=rd('dxg-cd'),cm=rd('dxg-cm');
    if(cd==='3'||cd==='4')s.setAttribute('data-cd',cd);
    s.setAttribute('data-cm',cm==='1'?'1':'2');
    function sync(){s.querySelectorAll('[data-dxg-cols]').forEach(function(b){var n=b.getAttribute('data-dxg-cols'),on=(n==='1'||n==='2')?s.getAttribute('data-cm')===n:s.getAttribute('data-cd')===n;b.classList.toggle('is-on',on);b.setAttribute('aria-pressed',on?'true':'false');});}
    s.querySelectorAll('[data-dxg-cols]').forEach(function(b){b.addEventListener('click',function(){var n=b.getAttribute('data-dxg-cols');if(n==='1'||n==='2'){s.setAttribute('data-cm',n);wr('dxg-cm',n);}else{s.setAttribute('data-cd',n);wr('dxg-cd',n);}sync();});});
    sync();

    function toGrid(){var b=s.querySelector('.dxg__body');if(!b)return;var y=b.getBoundingClientRect().top+window.pageYOffset-topH()-(bar?bar.offsetHeight:0);if(window.pageYOffset>y)window.scrollTo({top:y,behavior:'smooth'});}
    var ctrl=null;
    function render(url,o){
      o=o||{};
      if(ctrl)ctrl.abort();
      ctrl=window.AbortController?new AbortController():null;
      s.classList.add('is-load');
      var u=new URL(url,location.origin);u.searchParams.set('section_id',sid);
      return fetch(u.toString(),{signal:ctrl?ctrl.signal:undefined}).then(function(r){return r.text();}).then(function(html){
        var n=new DOMParser().parseFromString(html,'text/html').querySelector('[data-dxg]');
        if(!n){location.href=url;return;}
        var g=s.querySelector('[data-dxg-grid]'),ng=n.querySelector('[data-dxg-grid]');
        if(o.append){[].slice.call(ng.querySelectorAll('.dxg__card')).forEach(function(c,i){c.classList.add('is-new');c.style.setProperty('--i',i%8);g.appendChild(c);});}
        else{g.innerHTML=ng.innerHTML;}
        ['[data-dxg-more]','[data-dxg-count]','[data-dxg-active]','[data-dxg-go]'].forEach(function(q){var a=s.querySelector(q),b=n.querySelector(q);if(a&&b)a.innerHTML=b.innerHTML;});
        if(o.append){var pv=s.querySelector('.dxg__prev');if(pv)pv.remove();}
        else{
          var fc=s.querySelector('[data-dxg-fcount]'),nfc=n.querySelector('[data-dxg-fcount]');
          if(fc&&nfc){fc.textContent=nfc.textContent;fc.hidden=nfc.hidden;}
          var fb=s.querySelector('[data-dxg-fbody]'),nfb=n.querySelector('[data-dxg-fbody]');
          if(fb&&nfb){var op={},st=fb.scrollTop;fb.querySelectorAll('details').forEach(function(x){op[x.getAttribute('data-id')]=x.open;});fb.innerHTML=nfb.innerHTML;fb.querySelectorAll('details').forEach(function(x){var k=x.getAttribute('data-id');if(k in op)x.open=op[k];});fb.scrollTop=st;}
        }
        watch(g);if(window.dxgTool)window.dxgTool();
        s.classList.remove('is-load');
        if(o.push)history.pushState({dxg:1},'',url);
        if(o.scroll)toGrid();
      }).catch(function(e){if(e&&e.name==='AbortError')return;s.classList.remove('is-load');location.href=url;});
    }
    function formUrl(){
      var p=new URLSearchParams();
      if(form){new FormData(form).forEach(function(v,k){if(String(v)!=='')p.append(k,v);});}
      var q=p.toString();return base+(q?'?'+q:'');
    }

    s.addEventListener('click',function(e){
      var nx=e.target.closest('[data-dxg-next]');
      if(nx){e.preventDefault();nx.classList.add('is-load');nx.textContent='Chargement';render(nx.href,{append:true});return;}
      var ln=e.target.closest('[data-dxg-link]');
      if(ln&&s.contains(ln)){e.preventDefault();render(ln.href,{push:true,scroll:!dr||dr.hidden});return;}
      if(e.target.closest('[data-dxg-open]')){openDr();return;}
      if(e.target.closest('[data-dxg-close]')){closeDr();return;}
    });

    var sel=s.querySelector('[data-dxg-sort]');
    if(sel)sel.addEventListener('change',function(){
      var si=s.querySelector('[data-dxg-sortin]');if(si)si.value=sel.value;
      var url;if(form){url=formUrl();}else{url=base+'?sort_by='+encodeURIComponent(sel.value);}
      render(url,{push:true,scroll:true});
    });

    if(form){
      var tm=null;
      form.addEventListener('change',function(e){if(e.target.type==='number')return;render(formUrl(),{push:true});});
      form.addEventListener('input',function(e){if(e.target.type!=='number')return;clearTimeout(tm);tm=setTimeout(function(){render(formUrl(),{push:true});},700);});
      form.addEventListener('submit',function(e){e.preventDefault();clearTimeout(tm);var u=formUrl();if(u!==location.pathname+location.search){render(u,{push:true});}closeDr();toGrid();});
    }

    var last=null;
    function openDr(){if(!dr)return;last=document.activeElement;dr.hidden=false;document.documentElement.classList.add('dxg-lock');requestAnimationFrame(function(){requestAnimationFrame(function(){dr.classList.add('is-open');var x=dr.querySelector('.dxg__x');if(x)x.focus();});});}
    function closeDr(){if(!dr||dr.hidden)return;dr.classList.remove('is-open');document.documentElement.classList.remove('dxg-lock');setTimeout(function(){dr.hidden=true;},460);if(last&&last.focus)last.focus();}
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeDr();});
    window.addEventListener('popstate',function(){if(location.pathname===base)render(location.href,{});});

    s.addEventListener('click',function(e){
      var btn=e.target.closest('[data-dxg-add]');if(!btn)return;
      e.preventDefault();if(btn.classList.contains('is-load'))return;
      var lab=btn.querySelector('span');btn.classList.add('is-load');
      var cart=document.querySelector('cart-drawer')||document.querySelector('cart-notification');
      var body={id:Number(btn.getAttribute('data-dxg-add')),quantity:1};
      try{if(cart&&cart.getSectionsToRender){body.sections=cart.getSectionsToRender().map(function(x){return x.id;});body.sections_url=location.pathname;}}catch(err){}
      fetch((s.getAttribute('data-add-url')||'/cart/add')+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.json();}).then(function(res){
        if(res.status)throw res;
        btn.classList.remove('is-load');btn.classList.add('is-ok');if(lab)lab.textContent='Ajouté au panier';
        setTimeout(function(){btn.classList.remove('is-ok');if(lab)lab.textContent=lab.getAttribute('data-t')||'Ajouter au panier';},2400);
        var ok=false;
        try{if(cart&&cart.renderContents&&res.sections){cart.classList.remove('is-empty');cart.renderContents(res);ok=true;}}catch(err){}
        if(!ok){fetch('/cart.js').then(function(r){return r.json();}).then(function(c){document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function(x){x.textContent=c.item_count;});}).catch(function(){});}
        document.dispatchEvent(new CustomEvent('dx:cart-added',{detail:res}));
      }).catch(function(){btn.classList.remove('is-load');location.href='/cart';});
    });
  }
  function boot(){document.querySelectorAll('[data-dxg]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();